import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ChartPrescriptionListItemCode from "./ChartPrescriptionListItemCode";

import bindActions from "../../../../helpers/bindActions";
import * as chartSidePrescriptionActions from "../../../../actions/chartSidePrescriptionActions";
import DataList from "../../../widgets/DataList";
import { SidebarHeader } from "../../../sidebar/SidebarHeader";

const enhancer = connect(null, bindActions({ chartSidePrescriptionActions }));
export default enhancer(
  class ChartPrescriptionGroupList extends React.Component {
    static propTypes = {
      chartSidePrescriptionActions: PropTypes.object,
      chartSidePrescription: PropTypes.object,
    };

    componentDidMount() {
      this.props.chartSidePrescriptionActions.getPrescriptionGroupTemplates();
    }

    openItem = (item) => {
      return () => {
        this.props.chartSidePrescriptionActions.openItem(item.id);
      };
    };

    loadList = (e) => {
      const scrollBottom = e.target.scrollTop + e.target.offsetHeight + 1 >= e.target.scrollHeight;

      if (scrollBottom) {
        this.props.chartSidePrescriptionActions.loadPrescriptionGroupTemplates();
      }
    };

    toggleFavourite = (item) => {
      const favourites = JSON.parse(localStorage.getItem("PrescriptionFavourites"));

      if (!favourites[item.id]) {
        favourites[item.id] = item;
      }

      favourites[item.id].selected = !favourites[item.id].selected;

      localStorage.setItem("PrescriptionFavourites", JSON.stringify(favourites));

      this.forceUpdate();
    };

    render() {
      const { fetchingGroupTemplates, templatesGroupTemplates } = this.props.chartSidePrescription;

      const sortTemplate = _.sortBy(templatesGroupTemplates, (item) => item.name);

      const $list = sortTemplate.map((item, index) => (
        <ChartPrescriptionListItemCode
          toggleFavourite={(item) => this.toggleFavourite(item)}
          key={index}
          item={item}
          openItem={this.openItem(item)}
        />
      ));

      return (
        <div className="chart-clinical-note">
          <SidebarHeader onBackClick={this.props.chartSidePrescriptionActions.popStack} />
          <div className="chart-side-body">
            <div className="title">Select From Templates</div>
            {/*<ChartSideSearch value={searchValueTemplates} onChange={this.onSearch}/>*/}
            <div className="body">
              <div className="chart-side-body-wrapper">
                <DataList fetching={fetchingGroupTemplates} onScroll={this.onLoad}>
                  {$list}
                </DataList>
              </div>
            </div>
            <div className="all-codes">
              <button
                onClick={this.props.chartSidePrescriptionActions.openEmpty}
                className="btn btn-primary btn-block"
              >
                Write New
              </button>
            </div>
          </div>
        </div>
      );
    }
  },
);
